import React from 'react';
import PropTypes from 'prop-types';

import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import { states, additionalStates } from 'commons/usStates';

const getStatesList = includeAdditionalStates => {
  const allStates = includeAdditionalStates
    ? [...states, ...additionalStates]
    : states;
  if (includeAdditionalStates) {
    allStates.sort((a, b) => a.label.localeCompare(b.label));
  }
  return allStates.map(({ label, abbreviation }) => ({
    label,
    value: abbreviation,
  }));
};

const StateField = ({
  id = 'state',
  name = 'state',
  value,
  error,
  isTouched,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  updateShipping,
  includeAdditionalStates = false,
  isRequired = true,
}) => {
  const usStatesList = getStatesList(includeAdditionalStates);
  return (
    <LabeledSelectBox
      id={id}
      name={name}
      searchable={false}
      clearable={false}
      options={usStatesList}
      label="State *"
      onChange={event => {
        setFieldValue(name, event.target.value);
        setFieldTouched(name);

        if (updateShipping) {
          updateShipping({
            state: event.target.value,
          });
        }
      }}
      onBlur={handleBlur}
      value={value}
      autoComplete="address-level1"
      data-xc="shipping-state-field"
      errorMessage={isTouched && error ? error : null}
      required={isRequired ? '' : undefined}
      aria-required={isRequired ? '' : undefined}
      fullHeight
    />
  );
};

StateField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
  includeAdditionalStates: PropTypes.bool,
};

export default StateField;
